"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return (0, _typeof2["default"])(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if ((0, _typeof2["default"])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0, _typeof2["default"])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _default(map, key) {
  if (!map) {
    return map;
  }

  var deleted = map[key],
      nextMap = (0, _objectWithoutProperties2["default"])(map, [key].map(_toPropertyKey));
  return nextMap;
}